import classNames from "classnames";
import { isEmpty } from "lodash";
import Cost from "shared/components/Cost";
import Input from "shared/components/Input";
import { CURRENCY_SYMBOL } from "utils/constants";
import { costToFrench } from "utils/helpers/values";

const insurancePlan = ({
  logo,
  name,
  description,
  cost,
  currency = "DEFAULT",
  translation,
  checked,
  onCheck,
  justification,
  onJustify,
  upsells = [],
}) => {
  const totalCost = upsells
    ?.reduce((acc, curr) => acc + curr.cost, cost)
    ?.toFixed(2);

  return (
    <div className="insurance-card-container">
      <div className="insurance-card">
        <div className="insurance-card__checkbox">
          <Input
            type="checkbox"
            onChange={(e) => onCheck(e.target.checked)}
            checked={checked}
          />
        </div>
        <div className="insurance-card__image">
          {logo && <img src={logo} alt={name} />}
        </div>
        <div className="insurance-card__item">
          <div className="insurance-card__item--name">{name}</div>
          <span className="insurance-card__item--description">
            {description}
          </span>
        </div>
        <div className="insurance-card__item">
          <div className="insurance-card__item">
            <div>
              <Cost
                cost={totalCost || "-"}
                currency={currency}
                period={`/ ${translation.PER_MONTH}`}
              />
            </div>
            <span className="insurance-card__item--total">
              {`${costToFrench(+totalCost * 12, 2)} ${
                CURRENCY_SYMBOL[currency]
              } / ${translation.PER_YEAR} `}
              <span>{translation.ALL_COST}</span>
            </span>
          </div>
        </div>
      </div>
      <div
        className={classNames("insurance-card", {
          hidden: isEmpty(upsells),
        })}
      >
        <div className="insurance-card__checkbox"></div>
        <div className="insurance-card__image"></div>
        <div className="insurance-card__item">
          <div className="insurance-card__item--included">
            {translation.INCLUDED}
          </div>
          <div className="insurance-card__item--upsells">{name}</div>
          {upsells.map(({ insurancePlan: upsellPlan }) => (
            <div className="insurance-card__item--upsells" key={upsellPlan.id}>
              {upsellPlan?.name}
            </div>
          ))}
        </div>
        <div className="insurance-card__item justify--end">
          <Cost cost={cost || "-"} currency={currency} size="small" />
          {upsells.map(({ id, cost: upsellCost, currency: upsellCurrency }) => (
            <Cost
              key={id}
              cost={upsellCost || "-"}
              currency={upsellCurrency}
              size="small"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default insurancePlan;
